// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import ListItem from 'modules/TestSpecifications/components/ListItem';

// Other
import './styles.css';

const TestSpecificationList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='TestSpecificationList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No test specification to show here</h3>
		)
	}


	// Data State
	return (
		<div className='TestSpecificationList'>

			<div className='TestSpecificationList__header tr'>
				<span className='semi-bold'>Specification</span>
				<span className='semi-bold TestSpecificationList__header__code'>Code</span>
			</div>

			{items.map((item, index) => {

				return (
						<Link className='TestSpecificationList__link' to={'/testspecifications/' + item.id} key={index}>
							<ListItem 
								{...item} 
								isLoading={false}
								onChange={() => {onChange()}}
							/>
						</Link>
				)
				
			})}

		</div>
	)
}

TestSpecificationList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

TestSpecificationList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default TestSpecificationList;